

exports.__esModule = true;

var _squid = require('squid');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoExpiredFiPanel', {
    tag: 'xo-expired-fi-panel',
    template: _template2['default'],
    props: {
        token: {
            type: 'var',
            required: false
        },
        fi: {
            type: 'var',
            required: false
        }
    }
});


_squid.$Component;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ../node_modules/xo-ui-components/src/expired-fi-panel/directive.js
// module id = ../node_modules/xo-ui-components/src/expired-fi-panel/directive.js
// module chunks = 0